import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { parseToError } from 'src/app/shared/functions-angular';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  public error(message: unknown, error?: unknown): void {
    message = typeof message === 'function' ? message() : message;
    error = typeof error === 'function' ? error() : error;

    if(message instanceof HttpErrorResponse && (message.status === 401 || message.status === 403)) {
      // eslint-disable-next-line no-console
      console.log(message);
      Sentry.addBreadcrumb({data: message});
    } else {
      console.error(message);
      try {
        Sentry.captureMessage(
          typeof message === 'string' ?
          message :
          JSON.stringify(message)
        );
      } catch (logError) {
        Sentry.captureMessage(
          typeof logError === 'string' ?
          logError :
          'Failed to capture message!'
        );
        console.error(logError)
      }
    }

    if(error) {
      const parsedError = parseToError(error);
      if(parsedError && (parsedError.status === 401 || parsedError.status === 403)) {
        // eslint-disable-next-line no-console
        console.log(error);
        Sentry.addBreadcrumb({data: error});
      } else {
        console.error(error);
        Sentry.captureException(error);
      }
    }
  }

  public logInfo(message: string): void {
    // eslint-disable-next-line no-console
    console.info(message);
  }
}
